module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_vm._v("1")]), _vm._v(" Early Days "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("August 1914–March 1915")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter02"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_vm._v("2")]), _vm._v(" Front-line Impressions (“Plugstreet”) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("April 1915")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter03"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_vm._v("3")]), _vm._v(" “Plugstreet” Trenches "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("April 1915")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_vm._v("4")]), _vm._v(" Carrying on (“Plugstreet”) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("May")]), _vm._v(" 1915")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_vm._v("5")]), _vm._v(" Our New Sector (“Plugstreet”) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("June 1915")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_vm._v("6")]), _vm._v(" We Move Southward (Loos) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("July 1915")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_vm._v("7")]), _vm._v(" Hébuterne and Warnimont Wood "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("August 1915")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_vm._v("8")]), _vm._v(" Fonquevillers "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("September–October 1915")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_vm._v("9")]), _vm._v(" Winter Trenches (Fonquevillers) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("November–December 1915")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("10")]), _vm._v(" Offensive Preparations (Fonquevillers) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("January–March 1916")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("11")]), _vm._v(" Bangalore Torpedoes (Fonquevillers) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("April 1916")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("12")]), _vm._v(" Somme Battle Preparations (Hébuterne) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("May–June 1916")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("13")]), _vm._v(" The Somme Battle (Ovillers) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("July–August 1916")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("14")]), _vm._v(" Winter Discomforts (Mametz Wood, Bazentin) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("September–December 1916")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("15")]), _vm._v(" The Germans Withdraw (Bazentin, Péronne) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("January–March 1917")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("16")]), _vm._v(" Open Warfare (Ronnsoy, Lebucquière) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("April–June 1917")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("17")]), _vm._v(" The Salient (Ypres) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("July 1917")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("18")]), _vm._v(" Passchendaele Battles (Ypres) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("August–October 1917")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("19")]), _vm._v(" Vimy—Journey to Italy "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("October–November 1917")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("20")]), _vm._v(" Winter in Italy "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("December 1917–January 1918")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("21")]), _vm._v(" On the Piave Front (the Montello) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("February–March 1918")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("22")]), _vm._v(" War in the Mountains (Asiago Plateau) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("May 1918")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("23")]), _vm._v(" The Carriola Front "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("May–June 1918")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("24")]), _vm._v(" The Austrians Attack (Asiago Plateau) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("15th June 1918")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("25")]), _vm._v(" Interludes from the Front (Granezza, Venice) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("July–October 1918")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("26")]), _vm._v(" Our Last Battle (Asiago) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("27th October–2nd November 1918")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("27")]), _vm._v(" The White Flag (Val d’Assa) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("3rd November 1918")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("28")]), _vm._v(" Austrian Surrender (the Trentino) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("4th November 1918")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("29")]), _vm._v(" Finale (Northern Italy) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("November 1918–March 1919")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_vm._v("30")]), _vm._v(" Post-War Retrospection")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-147245f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 72
// module chunks = 0